// Access gate for the Document Extracts viewer (drilldown → Documents tab).
//
// The viewer surfaces the Phase-3 extraction artifacts (OCR markdown, structured
// JSON, extracted images) from the loan's `{dealId}-extracted` container.
//
// GENERALLY AVAILABLE: the Parsed / Extracted tab (and its "Parsed" chips/badge)
// are visible to everyone. The allowlist below is retained for reference / a
// quick rollback — to re-gate, restore the `isDev || ALLOWED.has(...)` body.
export const LOAN_EXTRACTS_ALLOWLIST = [
  "dev2@arrowservicing.com",
  "dev1@arrowservicing.com",
];

export const canSeeLoanExtracts = () => true;

export default canSeeLoanExtracts;
